(function (root, factory) {
    document.addEventListener('DOMContentLoaded', function () {
        root.sundiveScript = new factory(jQuery);
        root.sundiveScript.init();
    });
})(this, function ($) {
    var Self = this;
    this.headerNavigation = '';

    this.init = function () {
        this.forceFullScreen();
        this.carouselBox();
        this.injectIcon();
        this.mobileMenu();

        this.headerNavigation = $('#headerNavigation');
        this.header_scroll_effect();
        this.lazyCst();
        this.general();
        $(window).scroll(function () {
            Self.header_scroll_effect();
            Self.lazyCst();
        });
        this.scrollTobtn();
        this.viewportscroll();
        this.scrollTotop();
    };

    this.general = function () {
        var subMenuHoverEffect = function () {
            Self.headerNavigation.find(".has-dropdown").hover(
                function () {
                    if ($(window).width() < 1024) {
                        return;
                    }
                    $(this).find('.dropdown-menu').fadeIn();
                    $(this).addClass("hover");
                },
                function () {
                    if ($(window).width() < 1024) {
                        return;
                    }
                    $(this).find('.dropdown-menu').fadeOut();
                    $(this).removeClass("hover");
                }
            );
        };

        subMenuHoverEffect();
    };

    this.mobileMenu = function () {
        var header = $('#headerNavigation'),
            injectHtml = function () {
                var elm = header.find('.container-menu'),
                    html = $('<div class="mobile-button-wrapper"><a href="#" class="mobile-button-menu"><span></span><span></span><span></span></a></div>'),
                    dropdown = elm.find('.has-dropdown');
                dropdown.prepend('<span class="sub-menu-button"></span>');
                elm.append(html);
            },
            mobileMenuFunc = function () {
                var elm = header.find('.mobile-button-wrapper'),
                    button = elm.find('.mobile-button-menu');
                button.on('click', function (e) {
                    e.preventDefault();
                    $('body').toggleClass('mobile-menu-opened');
                    return false;
                });
            },
            mobileSubMenuFunc = function () {
                var elm = header.find('.container-menu'),
                    button = elm.find('.sub-menu-button');
                     
                button.on('click', function (e) {
                    e.preventDefault();
                    var elm = $(this);
                        parent = elm.parent();
                    parent.toggleClass('sub-menu-opened');
                    
                    if(elm.parent().hasClass('sub-menu-opened')){
                        parent.find(' > .dropdown-menu').slideToggle();    
                    }
                    else{
                        parent.find(' > .dropdown-menu').slideToggle();    
                    };

                    return false;
                });
            };
        header.length > 0 && injectHtml(), mobileMenuFunc(), mobileSubMenuFunc();
    };

    this.header_scroll_effect = function () {
        var scrollBarPosition = window.pageYOffset | document.body.scrollTop;
        if (scrollBarPosition >= 55) {
            this.headerNavigation.addClass('stay-header');
        } else {
            this.headerNavigation.removeClass('stay-header');
        }
    };

    this.injectIcon = function () {
        var elm = $('li[data-icon]');
        if (elm.length > 0) {
            elm.each(function () {
                var elm = $(this),
                    dataIcon = elm.data('icon'),
                    icon = $('<i class="fa fa-' + dataIcon + '"></i>');
                elm.prepend(icon);
            });
        }
    };

    this.lazyCst = function () {
        var scrollBarPosition = window.pageYOffset | document.body.scrollTop,
            iframeLazy = $('.cst-iframe-lazy'),
            scriptTrip = $('.cst-trip-advisor');
        if (scrollBarPosition >= 55 || $('#site-wrapper').height() <= $(window).height()) {
            if (iframeLazy.length > 0) {
                iframeLazy.each(function () {
                    if (!$(this).hasClass('cst-loaded')) {
                        $(this).addClass('cst-loaded');
                        $(this).attr('src', $(this).data('src'));
                    }
                });
            }
            if (scriptTrip.length > 0 && !scriptTrip.hasClass('cst-loaded')) {
                scriptTrip.addClass('cst-loaded');
                $.getScript(scriptTrip.data('script'), function () {
                    scriptTrip.addClass('trip-advisor-loaded');
                });
            }
            if (scriptTrip.length > 0 && scriptTrip.hasClass('trip-advisor-loaded')) {
                if (typeof window.taValidate !== 'undefined') {
                    scriptTrip.removeClass('trip-advisor-loaded');
                    window.taValidate();
                }
            }
        }
    };

    this.carouselBox = function () {
        var elm = $('.section-carousel-box, .section-image-and-lists');
        elm.length > 0 && elm.each(function () {
            var elm = $(this),
                carousel = elm.find('.the-carousel'),
                imageLists = elm.find('.image-lists-wrapper'),
                openPopup = function (dataPopup) {
                    var elm = $('#' + dataPopup),
                        popupOverlay = $('<div class="cst-popup-overlay" data-popup="' + dataPopup + '"></div>');
                    elm.length > 0 && elm.fadeIn(), $('body').prepend(popupOverlay), popupOverlay.click(function () {
                        closePopup(dataPopup);
                    });
                    return;
                },
                closePopup = function (dataPopup) {
                    var elm = $('#' + dataPopup),
                        popupOverlay = $('.cst-popup-overlay[data-popup="' + dataPopup + '"]');
                    elm.length > 0 && elm.fadeOut(), popupOverlay.fadeOut(function () {
                        popupOverlay.remove();
                    });
                    return;
                },
                sameHeight = function () {
                    var height = 0,
                        elm = carousel.find('.carousel-item');
                    elm.find('.the-content').css({
                        'height': ''
                    });
                    elm.each(function () {
                        var elm = $(this).find('.the-content');
                        if (height < elm.height()) {
                            height = elm.height();
                        }
                    });
                    elm.find('.the-content').css({
                        'height': height + 'px'
                    });
                },
                popupElement = function (elm) {
                    var basePopup = $('.carousel-box-base-popup');
                    basePopup.length == 0 && $('body').append('<div class="carousel-box-base-popup"></div>'), basePopup = $('.carousel-box-base-popup');
                    elm.find('.the-popup .popup-item').each(function () {
                        var elm = $(this),
                            id = elm.attr('id');
                        if (basePopup.find(id).length == 0) {
                            var detach = elm.detach();
                            basePopup.append(detach);
                        } else {
                            elm.remove();
                        }
                    });
                },
                popupElementList = function (elm) {
                    var basePopup = $('.carousel-box-base-popup');
                    basePopup.length == 0 && $('body').append('<div class="carousel-box-base-popup"></div>'), basePopup = $('.carousel-box-base-popup');
                    elm.find('.popup-item').each(function () {
                        var elm = $(this),
                            id = elm.attr('id');
                        if (basePopup.find(id).length == 0) {
                            var detach = elm.detach();
                            basePopup.append(detach);
                        } else {
                            elm.remove();
                        }
                    });
                };
            if (imageLists.length > 0) {
                popupElementList(imageLists);
                imageLists.find('li>a').click(function (e) {
                    e.preventDefault();
                    var dataPopup = $(this).data('popup');
                    openPopup(dataPopup);
                    return false;
                });
            }
            if (carousel.length > 0) {
                $(window).on('resize load', function () {
                    if (carousel.hasClass('slick-initialized')) {
                        sameHeight();
                    }
                });
                carousel.on('init', function () {
                    setTimeout(function () {
                        popupElement(elm);
                        carousel.find('.slick-cloned .lazyloading').removeClass('lazyloading').addClass('lazyload');
                        carousel.find('.carousel-item>a').click(function (e) {
                            e.preventDefault();
                            var dataPopup = $(this).data('popup');
                            openPopup(dataPopup);
                            return false;
                        });
                        sameHeight();
                    }, 300);
                }).slick({
                    autoplay: true,
                    autoplaySpeed: 2000,
                    infinite: true,
                    arrows: true,
                    prevArrow: '<button type="button" class="slick-prev"><span class="default-arrow arrow-prev"></span></button>',
                    nextArrow: '<button type="button" class="slick-next"><span class="default-arrow arrow-next"></span></button>',
                    slidesToShow: 4,
                    slidesToScroll: 1,
                    responsive: [{
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: 3
                        }
                    },
                    {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 2
                        }
                    },
                    {
                        breakpoint: 480,
                        settings: {
                            slidesToShow: 1
                        }
                    }
                    ]
                });
            }
        });
    };

    this.forceFullScreen = function () {
        var elm = $('.init-fullwidth'),
            wrapper = $('body');
        if (elm.length > 0) {
            var run = function () {
                elm.each(function () {
                    var _elm = $(this),
                        type = _elm.data("stretch-type") ? _elm.data("stretch-type") : 'full',
                        padding = "full-padded" === type ? "" : 0;
                    _elm.css({
                        "margin-left": 0,
                        "margin-right": 0,
                        "padding-left": padding,
                        "padding-right": padding
                    });
                    var leftOfsset = _elm.offset().left - wrapper.offset().left,
                        rightOffset = wrapper.outerWidth() - leftOfsset - _elm.parent().outerWidth();
                    _elm.css({
                        "margin-left": -leftOfsset,
                        "margin-right": -rightOffset,
                        "padding-left": "full-padded" === type ? leftOfsset : padding,
                        "padding-right": "full-padded" === type ? rightOffset : padding
                    });
                });
                elm.length && $(window).trigger("panelsStretchRows")
            };
            $(window).on("resize load", run);
            run();
        }
    };

    this.scrollTobtn = function () {
        var button = $('.immSlider-arrow');
        var page = $("html, body");
        var gap = $(window).height()-160;
        button.click(function () {
            page.animate({ scrollTop: gap }, 1000);

        });
    };

    this.viewportscroll = function () {
        $.fn.isInViewport = function () {
            let elementTop = $(this).offset().top;
            let elementBottom = elementTop + $(this).outerHeight();

            let viewportTop = $(window).scrollTop();
            let viewportBottom = viewportTop + $(window).height();

            return elementBottom > viewportTop && elementTop < viewportBottom;
        };

        $(window).scroll(function () {
            $('.section-grid-column-full').each(function () {
                var thissection = $(this);
                if (thissection.isInViewport()) {
                    var item = $(this).find('.col-md');
                    item.each(function () {
                        var thisitem = $(this);
                        if (!thisitem.hasClass('animated-run')) {
                            thisitem.addClass('animated-run');
                        }
                    });
                }
            });
        });
    };

    this.scrollTotop = function () {
        var button = $('.scroll-to-top');
        var page = $("html, body");
        var heightHalf = $(window).height()-500;
        button.click(function () {
            page.animate({ scrollTop: 0 }, 1000);

            return false;
        });
        $(window).scroll(function () {
            if ($(this).scrollTop() > heightHalf) {
                button.addClass('visible');
            }
            else {
                button.removeClass('visible');
            }

        });
    };
});